import React from 'react'
import PropTypes from 'prop-types'

const Panel = ({title, subtitle, children}) => {
	return (
		<div>
			<div className="panel-title-tab clearfix">{title}</div>
			<div className="panel panel-blue">
				<div className="panel-heading">
					{subtitle}
				</div>
				<div className="panel-body">
					{children}
				</div>
			</div>
		</div>
	)
}

Panel.propTypes = {
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string.isRequired,
	children: PropTypes.node
}

export default Panel



// WEBPACK FOOTER //
// ./client/components/layout/Panel/index.js